import React from "react";
import { Link, useSearchParams } from "react-router-dom";

const PaymentCancel: React.FC = () => {
  const [searchParams] = useSearchParams();
  const weddingId = searchParams.get("wedding_id");
  const rsvpId = searchParams.get("rsvp_id");
  const managePath =
    weddingId && rsvpId ? `/weddings/${weddingId}/rsvp/${rsvpId}` : null;

  return (
    <div className="page">
      <div className="error-message centered">
        <h1>Payment Cancelled</h1>
        <p>
          Your payment was not completed.
          {managePath
            ? " You can return to your RSVP to pay for unpaid plus-one seats or try again."
            : " You can try again from the wedding page."}
        </p>
        <div className="button-row" style={{ justifyContent: "center" }}>
          {managePath && (
            <Link to={managePath} className="btn btn-primary">
              Return to RSVP
            </Link>
          )}
          {weddingId && (
            <Link to={`/weddings/${weddingId}`} className="btn btn-secondary">
              View wedding
            </Link>
          )}
          <Link to="/weddings/public" className="btn btn-secondary">
            Browse Weddings
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
